export default __webpack_public_path__ + "static/media/02.4f911e51.jpg";